import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import { doc, updateDoc } from "firebase/firestore";
import { auth, db } from "../firebase";
import { useSubscriptionContext } from "./SubscriptionContext";

// Coincide con los beneficios anunciados en subscription.js.
const PLAN_LIMITS = {
  "Básico": 12,
  "Profesional": 20,
  "Premium": Infinity,
};

const ProtectedPublishButton = ({ children, projectId }) => {
  const [openModal, setOpenModal] = useState(false);
  const navigate = useNavigate();
  const { subscription } = useSubscriptionContext();

  const isActive = subscription?.status === "ACTIVE";
  const limit = PLAN_LIMITS[subscription?.planName] ?? 0;
  const proposalCount = subscription?.proposalCount || 0;

  const handlePublishClick = async () => {
    if (!isActive) {
      setOpenModal(true);
      return;
    }

    if (proposalCount >= limit) {
      setOpenModal(true);
      return;
    }

    navigate(`/publishProposal?proyectId=${projectId}`);

    if (auth.currentUser) {
      try {
        await updateDoc(doc(db, "users", auth.currentUser.uid), {
          "subscription.proposalCount": proposalCount + 1,
        });
      } catch (error) {
        console.error("Error updating proposal count:", error);
      }
    }
  };

  const getModalMessage = () => {
    if (!isActive) {
      return "Para publicar propuestas, necesitas tener una suscripción activa.";
    }
    return "Has alcanzado el límite de propuestas para tu plan actual.";
  };

  return (
    <>
      <Button
        fullWidth
        variant="outlined"
        color="primary"
        onClick={handlePublishClick}
        className="w-full"
      >
        {children}
      </Button>

      <Dialog open={openModal} onClose={() => setOpenModal(false)}>
        <DialogTitle>Suscripción Requerida</DialogTitle>
        <DialogContent>
          <Typography>{getModalMessage()}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenModal(false)} variant="outline">
            Cancelar
          </Button>
          <Button
            onClick={() => {
              setOpenModal(false);
              navigate("/subscription");
            }}
          >
            Ver Planes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ProtectedPublishButton;
